import React from "react";
import AnimatedPage from "../animated/AnimatedPage";

function Article() {
  return (
    <AnimatedPage>
      <section class="content">
        <p>
          +2 years experienced in IT and an expert front-end developer,
          interested in writing codes, Devoted to his profession; talented at
          producing efficient and attractive UI designs with a holistic
          view;determined to fulfill commitments; self-confident to create
          satisfactory and outstanding applications for customer relationships;
          interested in creating algorithms and programming especially for
          HTML5, CSS3, React.js, Redux. JavaScript and Python; deeply
          self-motivated to continuously improve technical skills; enthusiastic
          about implementing distinct perspectives and learning current trends
          and tools; experienced in working with multicultural teams and
          environment, leadership, team cohesion and communication issues.
        </p>
        <p>And I'm lifetime student. &#129489;&#8205;&#127891;</p>
      </section>
    </AnimatedPage>
  );
}

export default Article;
